import { SwiperSlide } from 'swiper/react'
import { MenuItemType } from '@utils/types'
import { WImage } from '../../atoms'
import GalleryModal from '../GalleryModal/GalleryModal'
import styles from './CarouselGalleryModal.module.sass'

interface Props {
  className?: string
  id?: string
  item?: MenuItemType
  initialSlide?: number
  open?: boolean
  onClose?: () => void
}

const CarouselGalleryModal = (props: Props) => {
  const {
    id = undefined,
    item = undefined,
    initialSlide = 0,
    open = false,
    onClose = undefined,
    className = '',
  } = props

  return item?.children?.length ? (
    <GalleryModal
      id={id}
      items={item?.children}
      zoom
      paginationStyle="thumbs"
      initialSlide={initialSlide}
      open={open}
      onClose={onClose}
      className={`${styles.root} ${className}`}
      mainSwiperClassName={styles.mainSwiper}
    >
      {item?.children.map((x) => (
        <SwiperSlide key={x.pk}>
          <div className={`${styles.imageBox} swiper-zoom-wrapper`}>
            <div className={`swiper-zoom-container`}>
              <WImage
                src={x.image}
                alt={x?.imageAlt}
                maxWidth={1240}
                maxHeight={560}
                className={styles.image}
              />
            </div>
          </div>
        </SwiperSlide>
      ))}
    </GalleryModal>
  ) : (
    <></>
  )
}

export default CarouselGalleryModal
